import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/privacy-policy/_components/PrivacyPolicyContent.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")